// jkc的接口code码
export enum JkcHttpStatusCode {
  Success = '0'
}

// 订单状态（JKC）
// 对应业务状态流转如下：
// 1-待派单 -> 2-派单成功 -> 3-接货中 -> 4-待装货 -> 5-装货中 -> 6-行程中 -> 7-待卸货 -> 8-卸货中 -> 9-已完成
// 中途各阶段可能取消：2/3/4/5阶段由物流小哥触发取消订单进入10-已取消；6/7/8阶段由客服取消订单进入10-已取消
// 11-车辆等待出发、12-已装载为补充状态，用于更细粒度的车辆/装载环节标识
export enum OrderStateEnum {
  /** 1-待派单：物流小哥发起呼叫，尚未匹配到车辆 */
  WAIT_DISPATCH = 1,
  /** 2-派单成功：已匹配到车辆 */
  DISPATCHED = 2,
  /** 3-接货中：车辆前往装货点途中 */
  PICKUP_EN_ROUTE = 3,
  /** 4-待装货：车辆到达装货点，等待装货 */
  WAIT_LOAD = 4,
  /** 5-装货中：物流小哥解锁车辆，正在装货 */
  LOADING = 5,
  /** 6-行程中：物流小哥点击装货完成，车辆开始前往卸货点 */
  IN_TRANSIT = 6,
  /** 7-待卸货：车辆到达卸货点，等待卸货 */
  WAIT_UNLOAD = 7,
  /** 8-卸货中：物流小哥解锁车辆，正在卸货 */
  UNLOADING = 8,
  /** 9-已完成：物流小哥点击卸货完成，订单结束 */
  COMPLETED = 9,
  /** 10-已取消：各阶段可能由物流小哥/客服取消订单 */
  CANCELLED = 10,
  /** 11-车辆等待出发：车辆已就绪，等待任务开始 */
  VEHICLE_WAIT_START = 11,
  /** 12-已装载：货物已装载完成，待发车/后续流程 */
  LOADED = 12
}

// 订单状态中文映射
export const OrderStateEnumNameMap: Record<OrderStateEnum, string> = {
  [OrderStateEnum.WAIT_DISPATCH]: '待派单',
  [OrderStateEnum.DISPATCHED]: '派单成功',
  [OrderStateEnum.PICKUP_EN_ROUTE]: '接货中',
  [OrderStateEnum.WAIT_LOAD]: '待装货',
  [OrderStateEnum.LOADING]: '装货中',
  [OrderStateEnum.IN_TRANSIT]: '行程中',
  [OrderStateEnum.WAIT_UNLOAD]: '待卸货',
  [OrderStateEnum.UNLOADING]: '卸货中',
  [OrderStateEnum.COMPLETED]: '已完成',
  [OrderStateEnum.CANCELLED]: '已取消',
  [OrderStateEnum.VEHICLE_WAIT_START]: '车辆等待出发',
  [OrderStateEnum.LOADED]: '已装载'
};

// 路径点类型（JKC）
export enum RoutePointType {
  /** 上车点 */
  PICKUP_POINT = 'PICKUP_POINT',
  /** 下车点 */
  DROP_OFF_POINT = 'DROP_OFF_POINT',
  /** 停靠点 */
  PARK_POINT = 'PARK_POINT',
  /** 途经点 */
  WAY_POINT = 'WAY_POINT'
}

// 路径点类型中文映射
export const RoutePointTypeNameMap: Record<RoutePointType, string> = {
  [RoutePointType.PICKUP_POINT]: '上车点',
  [RoutePointType.DROP_OFF_POINT]: '下车点',
  [RoutePointType.PARK_POINT]: '停靠点',
  [RoutePointType.WAY_POINT]: '途经点'
};

// 单车页展示出来的EDA距离的最小值（单位为公里，当距离小于此值时展示此值）
export const MIN_SHOW_DISTANCE_KM = 0.1;

/**
 * jkc业务的埋点key
 */

// 1. qidianLog的埋点id
export enum JKC_QIDIAN_LOG_ID {
  /** 订单详情页面底部的主按钮 */
  remoteControl = 'remoteControl', // 遥控
  openTheDoorAndLoadGoods = 'openTheDoorAndLoadGoods', // 开门装货
  viewThePackageToBePickedUp = 'viewThePackageToBePickedUp', // 查看包裹
  unlockTheVehicleDoor = 'unlockTheVehicleDoor', // 解锁车门

  /** 订单详情页面底部的主按钮点击后出来的弹窗按钮 */
  // 取消订单弹窗
  cancelOrderCancel = 'cancelOrderCancel',
  cancelOrderConfirm = 'cancelOrderConfirm',
  // 装货完毕 发车 弹窗
  loadingCompletedAndTheVehicleDepartedCancel = 'loadingCompletedAndTheVehicleDepartedCancel',
  loadingCompletedAndTheVehicleDepartedConfirm = 'loadingCompletedAndTheVehicleDepartedConfirm',
  // 结束用车 弹窗
  pickupCompletedAndTheProcessFinishedCancel = 'pickupCompletedAndTheProcessFinishedCancel',
  pickupCompletedAndTheProcessFinishedConfirm = 'pickupCompletedAndTheProcessFinishedConfirm',
  // 记录包裹 弹窗
  recordShippingPackagesCancel = 'recordShippingPackagesCancel',
  recordShippingPackagesConfirm = 'recordShippingPackagesConfirm',
  // 联系客服 弹窗
  callCustomerServiceCancel = 'callCustomerServiceCancel',
  callCustomerServiceConfirm = 'callCustomerServiceConfirm'
}
